import clsx from 'clsx';

import {InlinePortableText} from '../inline-portable-text';

import type {ColorBlockFragment} from './query';

type Props = {
	content: ColorBlockFragment['content'];
	themeColor: ColorBlockFragment['themeColor'];
};

export const ColorBlock = ({content, themeColor}: Props) => {
	return (
		<div className={clsx('my-8', getThemeColor(themeColor), 'p-4', 'md:p-8', 'rounded-lg')}>
			{content && content.length > 0 ? <InlinePortableText value={content} /> : null}
		</div>
	);
};

const getThemeColor = (color: ColorBlockFragment['themeColor']) => {
	switch (color) {
		case 'green':
			return 'bg-success-90';
		case 'orange':
			return 'bg-warning-95';
		default:
			return '';
	}
};
